import PropTypes from 'prop-types';
import React from 'react';

import htmlToDraft from 'html-to-draftjs';
import { stateToHTML } from 'draft-js-export-html';
import { ContentState, EditorState } from 'draft-js';
import Popup from 'reactjs-popup';

const popupContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "220px",
  "padding": "0px",
  "zIndex": "3000"
};

// https://ourcodeworld.com/articles/read/376/how-to-strip-html-from-a-string-extract-only-text-content-in-javascript
const stripHtml = (html) => {
  var temporalDivElement = document.createElement("div");
  temporalDivElement.innerHTML = html;
  return temporalDivElement.textContent || temporalDivElement.innerText || "";
};

const canSubmit = (draft, editorState) => {
  var stateHTML = stateToHTML(editorState.getCurrentContent());
  var content = stripHtml(stateHTML);

  return (
    draft
      && draft.title
      && draft.title.length > 0
      && content.length > 0
  );
};

const replaceEditorContent = (html, onEditorStateChange) => {
  var { contentBlocks, entityMap } = htmlToDraft(html);
  var newContentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
  onEditorStateChange(EditorState.createWithContent(newContentState));
};

const AddOnMessageTemplates = ({
  csrfToken,
  team,
  kind,
  editorState,
  onEditorStateChange,
  templates,
  draft,
  draftChanged,
  createTemplate,
  deleteTemplate
}) => {
  return (
    <span style={{"margin": "-3px -2px 2px auto"}}>
      <Popup arrow={false}
             offsetY={3}
             position="bottom right"
             contentStyle={popupContentStyle}
             onClose={() => {
               draftChanged(kind, {});
             }}
             onOpen={(e) => {
               e.preventDefault();
             }}
             trigger={open => (
               <a href="#"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  style={{"padding": "2px 8px"}}
                  className="btn btn-muted small btn-sm">
                 Templates
                 <i className="fas fa-caret-down ml-2"></i>
               </a>
             )}>
        {close => (
          <div className="row">
            <div className="col-12"
                 style={{"padding": "13px 30px 0px 30px"}}>
              <p style={{
                   "color": "#999999",
                   "fontSize": "10px",
                   "marginBottom": "13px"
                 }}>
                APPLY A TEMPLATE
              </p>
              {templates.length === 0 ? (
                <div className="row">
                  <div className="col-12 text-center">
                    <p className="small text-muted"
                       style={{"marginBottom": "20px", "color": "#999999"}}>
                      No saved templates yet.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="row add-on-message-templates"
                     style={{
                       "borderTop": "1px dashed #F2F2F2",
                       "maxHeight": "110px",
                       "overflowY": "auto"
                     }}>
                  {[...templates].sort((a, b) => a.title.localeCompare(b.title)).map((template) => (
                    <div key={template.id}
                         className="col-12 add-on-message-template"
                         style={{"paddingTop": "10px", "paddingBottom": "10px"}}>
                      <div className="row">
                        <div className="col d-flex align-items-center">
                          <p className="mb-0 small text-overflow-ellipsis"
                             style={{"maxWidth": "125px"}}
                             title={template.title}>
                            <a href="#"
                               onClick={(e) => {
                                 e.preventDefault();
                                 replaceEditorContent(template.sanitized_body, onEditorStateChange);
                                 close();
                               }}
                               className="text-dark add-on-message-template-link">
                              {template.title}
                            </a>
                          </p>
                        </div>
                        <div className="col-xs-auto d-flex align-items-center"
                             style={{"paddingRight": "15px"}}>
                          <a href="#"
                             className="delete-add-on-message-template-link"
                             onClick={(e) => {
                               e.preventDefault();
                               deleteTemplate(csrfToken, team, template);
                             }}>
                            <i className="fas fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="row"
                   style={{
                     "borderTop": "1px solid #F2F2F2",
                     "paddingTop": "4px",
                     "paddingBottom": "6px"
                   }}>
                {Object.keys(draft).length === 0 ? (
                  <div className="col-12 text-center"
                       style={{"paddingTop": "5px", "paddingBottom": "7px"}}>
                    <a href="#"
                       style={{"fontSize": "10px", "fontWeight": "600"}}
                       onClick={(e) => {
                         e.preventDefault();
                         draftChanged(kind, { title: "" });
                       }}>
                      Save New Template
                    </a>
                  </div>
                ) : (
                  <div className="col-12"
                       style={{"paddingLeft": "6px", "paddingRight": "6px"}}>
                    <div className="input-group input-group-sm">
                      <input type="text"
                             autoFocus={true}
                             className="form-control border-0"
                             style={{
                               "background": "#f9f9f9",
                               "fontSize": "12px",
                               "borderTopLeftRadius": "4px",
                               "borderBottomLeftRadius": "4px"
                             }}
                             value={draft.title || ""}
                             onKeyDown={(e) => {
                               if (e.key === 'Enter') {
                                 e.preventDefault();
                                 if (canSubmit(draft, editorState)) {
                                   var body = stateToHTML(editorState.getCurrentContent());
                                   createTemplate(csrfToken, team, kind, draft, body, () => close());
                                 }
                               }
                             }}
                             onChange={(e) => {
                               draftChanged(kind, Object.assign({}, draft, { title: e.target.value }));
                             }}
                             placeholder="Enter a name" />
                      <div className="input-group-append">
                        <button className="btn btn-muted btn-muted-primary border-0"
                                disabled={!canSubmit(draft, editorState)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (canSubmit(draft, editorState)) {
                                    var body = stateToHTML(editorState.getCurrentContent());
                                    createTemplate(csrfToken, team, kind, draft, body, () => close());
                                  }
                                }}
                                style={{
                                  "fontSize": "12px",
                                  "borderTopRightRadius": "4px",
                                  "borderBottomRightRadius": "4px"
                                }}
                                type="button">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Popup>
    </span>
  );
};

AddOnMessageTemplates.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  kind: PropTypes.oneOf(["intro", "alert"]).isRequired,
  editorState: PropTypes.object.isRequired,
  onEditorStateChange: PropTypes.func.isRequired,
  templates: PropTypes.array.isRequired,
  draft: PropTypes.object.isRequired,
  draftChanged: PropTypes.func.isRequired,
  createTemplate: PropTypes.func.isRequired,
  deleteTemplate: PropTypes.func.isRequired
};

export default AddOnMessageTemplates;
